import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommonDataService {
  constructor() {}

  default_country_code = 'IN';
  default_storage_format = 'yyyy-MM-dd'; // SPECIALLY USED TO CONVER DATE OBJ TO API OF POST & PUT to CONVERT DB STORAGE FORMAT

  // FOR GRIDVIEW

  default_sort_parameter = 'created_at';
  default_sort_type = 'desc';
  default_date_pipe_format: string = 'dd-MM-yyyy';
  default_dateTime_pipe_format: string = 'dd-MM-yyyy HH:mm';

  default_limit = 10;
  limit_arr = [
    {
      value: 10,
      lable: 10,
    },
    {
      value: 20,
      lable: 20,
    },
    {
      value: 50,
      lable: 50,
    },
    {
      value: 100,
      lable: 100,
    },
  ];
  languages:any = [];
  selected_language = 'ENGLISH';

  language_data: any = null;
  english_value_obj: any = null;
  show_language_selector: boolean = false;

  getTotalPages(total_records: number, limit: number) {
    // Handle potential errors
    if (total_records === 0 || limit <= 0) {
      return 0;
    }
    // Calculate total pages using ceil to round up in case of non-exact division
    return Math.ceil(total_records / limit);
  }

  // FOR GRIDVIEW END
}
